// Listen for changes on your custom checkbox
document.addEventListener("DOMContentLoaded", function () {
  const mmCheckbox = document.querySelector("#mmCheckbox");

  if (!mmCheckbox) return;

  // Function to sync checkbox with variant option
  function syncCheckboxWithVariant() {
    const selectedMadeToMeasure = document.querySelector('input[name="Made to Measure"]:checked');

    if (selectedMadeToMeasure && selectedMadeToMeasure.value === "Yes") {
      mmCheckbox.checked = true;
    } else {
      mmCheckbox.checked = false;
    }
  }

  // Run sync once on page load
  syncCheckboxWithVariant();

  // When checkbox is toggled → update variant
  mmCheckbox.addEventListener("change", function () {
    let targetValue = mmCheckbox.checked ? "Yes" : "No";

    const targetOption = document.querySelector(
      `input[name="Made to Measure"][value="${targetValue}"]`
    );

    if (targetOption) {
      targetOption.checked = true;
      targetOption.dispatchEvent(new Event("change", { bubbles: true })); // trigger Shopify update
    }
  });
});
